export enum EnrichErrorType {
  CREDENTIALS_EXPIRED = 'Credentials Expired',
}



// WEBPACK FOOTER //
// ./src/app/models/error-type.enum.ts